export default "/images/vendor/@coreui/icons/svg/flag/cif-uy.svg?79cc7bbc8244b666a725260d5962df59";